import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import { datatabledata } from "../../../Common/data";
import TableContainer from "../../../Common/TableContainer";

const Datatables = () => {
  const columns = React.useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Job",
        accessorKey: "job",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Year",
        accessorKey: "year",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Country",
        accessorKey: "country",
        enableColumnFilter: false,
        enableSorting: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Datatables" pageType="table" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Data Table
            </h2>
            <div className="space-y-4 overflow-auto">
              <TableContainer
                columns={columns}
                data={datatabledata}
                isGlobalFilter={true}
                customPageSize={5}
                isSelect={true}
                isPagination={true}
                divclassName="overflow-auto"
                tableclassName="min-w-[640px] w-full striped"
                PaginationClassName="flex justify-between"
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Datatables;
